import wx from 'weixin-js-sdk'

export default function wechatConfig(jsApiList) {
  jsApiList = new Set([...jsApiList])
  return new Promise((resolve, reject) => {
    window.apis.wechatConfig({
        url: location.href.split('#')[0],
        jsApiList
      })
      .then(res => {
        if (process.env.NODE_ENV === 'development') {
          wx.config(res)
          resolve(res)
        } else {
          wx.config(res.data.config)
          resolve(res.data.config)
        }
      })
      .catch(e => {
        reject(e)
      })
  })
}


// WEBPACK FOOTER //
// ./src/lib/wechat-config-fn.js